// src/Public/Header.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css";
import config from "../config.json";
const Header = ({ title = "Privacy Policy" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <header className="header-container" style={{ borderBottom: "1px solid var(--border-subtle)" }}>
      <div className="d-flex align-items-center gap-2">
        <button onClick={handleBack} className="header-icon-btn" aria-label="Go back" style={{ cursor: "pointer", border: "1px solid var(--border-subtle)" }}>
          <i className="fi fi-rr-arrow-left"></i>
        </button>
        <div>
          <div className="fw-bold" style={{ fontSize: "16px", color: "var(--primary-dark)", lineHeight: 1.2 }}>
            {title}
          </div>
          <small className="text-muted" style={{ fontSize: "11px" }}>
            {config.apptitle} - {process.env.REACT_APP_ENV === "QA" ? "." : ""}
          </small>
        </div>
      </div>

      <div className="header-actions">
        <button onClick={() => navigate("/")} className="header-icon-btn" title="Home" aria-label="Home" style={{ cursor: "pointer" }}>
          <i className="fi fi-rr-home"></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
